import { useIncidentAudio } from '../../hooks/useIncidentAudio'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { HiSpeakerWave } from 'react-icons/hi2'

import { Alert, Box, Button, Stack } from '@hivewatch/dark'

import { SettingsGroup } from '@/features/settings'
import { useAppSelector } from '@/redux/hooks'
import { selectAreNotificationsMuted } from '@/redux/notifications/notificationsSlice'
import { trackEvent } from '@/utils/analytics'

import { AUDIO_SETTINGS_ANALYTICS } from '../../constants/constants'
import { SettingsToggleRow } from './SettingsToggleRow'

export const AudioSection = () => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const {
    toggleAudioEnabled,
    playAlertSound,
    isEnabled,
    isUpdatingAudioSetting,
  } = useIncidentAudio()
  const areNotificationsMuted = useAppSelector(selectAreNotificationsMuted)

  const testSound = async () => {
    trackEvent(AUDIO_SETTINGS_ANALYTICS.testAlert)
    await playAlertSound()
  }

  return (
    <SettingsGroup
      colorScheme={colorScheme}
      title={t('settings:rebrand_account_audio_group_title')}
    >
      <SettingsToggleRow
        colorScheme={colorScheme}
        dataTestId='audio-alerts'
        disabled={isUpdatingAudioSetting}
        isOn={isEnabled}
        label={t('settings:rebrand_account_audio_label')}
        onChange={() => void toggleAudioEnabled()}
      />

      {isEnabled && (
        <Stack gap='12px' w='full'>
          <Alert
            colorScheme={colorScheme}
            description={t(
              'settings:rebrand_account_audio_mute_override_description'
            )}
            title={t('settings:rebrand_account_audio_mute_override_title')}
            variant='info'
          />

          {areNotificationsMuted && (
            <Alert
              colorScheme={colorScheme}
              description={t(
                'settings:rebrand_account_audio_override_enabled_description'
              )}
              title={t('settings:rebrand_account_audio_override_enabled_title')}
              variant='warning'
            />
          )}

          <Box>
            <Button
              colorScheme={colorScheme}
              leftIcon={<HiSpeakerWave />}
              onClick={testSound}
              variant='secondary'
            >
              {t('settings:rebrand_account_audio_test_button')}
            </Button>
          </Box>
        </Stack>
      )}
    </SettingsGroup>
  )
}
